import React, { useMemo } from "react";
import { Entity } from "@common/types/entity";
import { ChildrenProps } from "../../../types";
import { AccountsConnectionContext } from "./AccountsConnectionContext";

interface AccountsConnectionProviderProps extends ChildrenProps {
    showAccountTypeWarning: boolean;
    defaultEntity?: Entity;
}

export const AccountsConnectionProvider: React.FC<
    AccountsConnectionProviderProps
> = ({ children, showAccountTypeWarning, defaultEntity }) => {
    const value = useMemo(
        () => ({
            showAccountTypeWarning,
            defaultEntity,
        }),
        [showAccountTypeWarning, defaultEntity],
    );

    return (
        <AccountsConnectionContext.Provider value={value}>
            {children}
        </AccountsConnectionContext.Provider>
    );
};
